<template>
  <v-main>
    <v-container style="min-height: 100vh">
      <VRow class="mt-10 mb-5">
        <VRow class="align-center" sm="5">
          <div>
            <VIcon class="mx-5" large>mdi-store</VIcon>
          </div>
          <div>
            <h2>{{ "my_socials_title" | localize }}</h2>
          </div>
          <div>
            <h2>
              <span class="ml-6" style="color: silver">{{ hoozies }}</span>
            </h2>
          </div>
        </VRow>
        <VCol v-if="loggedUser.isOwner === true">
          <v-btn
            :outlined="$vuetify.breakpoint.xs ? true : false"
            color="#72AFE7"
            @click="$router.push({name: 'addSocials'})"
            :class="
              $vuetify.breakpoint.xs
                ? 'a_btn_bl d-flex my-auto ml-auto add'
                : 'a_btn_wh d-flex my-auto ml-auto add'
            "
          >
            <span >{{ "button_add_socials" | localize }}</span>
          </v-btn>
        </VCol>
      </VRow>
      <social-list @checkHoozies="changeCount" />
    </v-container>
  </v-main>
</template>

<script>
import socialList from "@/components/Social/socialList";
import { mapGetters } from "vuex";
export default {
  components: {
    socialList,
  },
  data: () => ({
    hoozies: null,
  }),
  computed: {
    ...mapGetters(["loggedUser"]),
  },
  methods:{
      changeCount(socials) {
      let balance = socials.reduce((acc, sum) => acc + sum.balance.total, 0);
      if (balance % 1 == 0) {
        this.hoozies = "• " + balance.toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + " HZ";
      } else {
        this.hoozies = "• " + parseFloat(balance).toFixed(2).toString().replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.') + " HZ";
      }
    },
  }
};
</script>

<style scoped>
.a_btn_bl span ::v-deep {
  color: #000 !important;
  text-decoration: none;
}
.a_btn_wh span ::v-deep {
  color: #fff !important;
  text-decoration: none;
}
</style>